/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import { Icon, Image, Text, Title } from './core';
import Colors from '../constants/Colors';
import Responsive from '../constants/Responsive';
import type { ReviewType } from '../../data/Reviews';

class Review extends React.Component<{
  review: ReviewType,
  theme: 'light' | 'dark',
}> {
  static defaultProps = {
    theme: 'dark',
  };

  render() {
    let { review, theme } = this.props;
    let { avatar, name, review: reviewString } = review;

    return (
      <div className={Styles.Container}>
        <div className={Styles.Profile}>
          <div className={Styles.AvatarWrapper}>
            <div className={Styles.Avatar}>
              <Image className={Styles.AvatarImage} src={avatar} />
            </div>
            <Icon name="quote-badge" className={Styles.Icon} />
          </div>
          <div className={Styles.Name}>
            <Title size="22" weight="bold" color={ThemeStyles[theme].TitleColor} align="left">
              {name}
            </Title>
            {[0, 1, 2, 3, 4].map(i => (
              <Icon name={ThemeStyles[theme].StarIcon} className={Styles.Star} key={i} />
            ))}
          </div>
        </div>
        <Text size={Responsive('18', '20')} align="center" color={ThemeStyles[theme].TextColor}>
          {`"${reviewString}"`}
        </Text>
      </div>
    );
  }
}

const ThemeStyles = {
  light: {
    TextColor: Colors.Black,
    TitleColor: Colors.Black,
    StarIcon: 'star-violet',
  },
  dark: {
    TextColor: Colors.White,
    TitleColor: Colors.White,
    StarIcon: 'star-yellow',
  },
};

const Styles = {
  Container: css`
    width: 100%;
  `,
  Profile: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
  `,
  AvatarWrapper: css`
    position: relative;
  `,
  Avatar: css`
    width: 64px;
    height: 64px;
    border-radius: 50%;
    overflow: hidden;
  `,
  AvatarImage: css`
    width: 100%;
  `,
  Name: css`
    padding-left: 24px;
  `,
  Star: css`
    margin-right: 6px;
  `,
  Icon: css`
    position: absolute;
    bottom: -4px;
    right: -8px;
  `,
};

export default Review;



// WEBPACK FOOTER //
// ./src/ui/components/Review.js